// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './Price.module.scss';;


type Props = {
  children: React.Node,
  className?: string,
}

const Price = ({ children, className }: Props) => (
  <span className={classNames(styles.root, className)}>{children}</span>
);

export default Price;
